import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { GroupClassDetailsModel, GroupClassParticipantsModel } from '@bayclubs/group-classes-employee-api';
import { GlobalEventsService } from 'src/app/infrastructure/infrastructure.module';
import { gcManagementEnumerations } from '../../../interfaces/interfaces.module';
import { FiltersStorageService, GroupClassesApiService } from '../../../shared/shared.module';

@Component({
    selector: 'app-group-classes-details',
    templateUrl: './group-classes-details.component.html',
    styleUrls: ['./group-classes-details.component.scss'],
    standalone: false
})
export class GroupClassesDetailsComponent implements OnInit, OnDestroy {
    public model: GroupClassDetailsModel;

    public hasAttendance: boolean = false;
groupOptions: any[] = [];

    private subscriptions: Subscription[] = [];

    constructor(
        private api: GroupClassesApiService,
        private route: ActivatedRoute,
        private router: Router,
        private globalEvents: GlobalEventsService,
        private filtersStorageService: FiltersStorageService
    ) {}

    ngOnInit() {
        this.groupOptions = this.getGroupOptions();
        this.subscriptions.push(
            this.route.params.subscribe(x => {
                if (x.id) {
                    this.load(x.id);
                }
            })
        );

        this.subscriptions.push(
            this.globalEvents.onGroupClassAdded$.subscribe(() => this.router.navigate(['management/classes']))
        );
        this.subscriptions.push(this.globalEvents.onGroupClassUpdated$.subscribe(() => this.load(this.model.id)));
    }

    onClassesClicked() {
        const url = this.filtersStorageService.listUrl || '/management/classes';
        this.router.navigateByUrl(url);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(i => i.unsubscribe());
    }

    public load(classesId: string): void {
        this.api.getDetails(classesId.toString()).subscribe(result => {
            this.model = result;
        });
    }

    public onAttendanceLoaded(attendance: GroupClassParticipantsModel) {
        this.hasAttendance =
        attendance &&
        attendance.items &&
        attendance.items.filter(x => x.status.code === gcManagementEnumerations.GroupClassStatus.active.code).length > 0;
    }


    getGroupOptions(): any[] {
        const options = [
            {
                name: 'Absolute Barre',
                type: 'Fitness',
                id: '1'
            },
            {
                name: 'Barre',
                type: 'Fitness',
                id: '2'
            },
            {
                name: 'Breakaway',
                type: 'Fitness',
                id: '3'
            },
            {
                name: 'Cardio',
                type: 'Fitness',
                id: '4'
            },
            {
              name: 'Yoga',
              type: 'Body & mind',
              id: '5'
          },
          {
              name: 'Heated Yoga',
              type: 'Body & mind',
              id: '6'
          },
          {
              name: 'Mountain cycling',
              type: 'Cycling',
              id: '7'
          },
          {
              name: 'Speed cycling',
              type: 'Cycling',
              id: '8'
          }
        ];

        return options;
    }

}
